import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { ToastrService } from 'ngx-toastr';
import { ApisService } from '../../services/apis.service';

@Component({
  selector: 'app-amend-position',
  templateUrl: './amend-position.component.html',
  styleUrls: ['./amend-position.component.scss']
})
export class AmendPositionComponent implements OnInit {

  @Input() jockey;
  @Input() race;
  userId: number;
  meta: {
    saving: boolean,
    enableSave: boolean
  };
  newPosition: number;
  possiblePositions: number[];

  constructor(
    public activeModal: NgbActiveModal,
    private apiService: ApisService,
    private notification: ToastrService
  ) { }

  ngOnInit() {
    // console.log('[ DEBUG ] Data received:', this.jockey);
    this.meta = {
      saving: false,
      enableSave: false
    }

    this.apiService.observableLoggedIn.subscribe(data => {
      this.userId = data.user_id;
    });

    const lastPosition = this.race.runners.filter(r => !r.nonRunnerCode).length;
    this.possiblePositions = Array.from({length: lastPosition}, (v, k) => k + 1);

  }

  enableSave(newPosition) {
    this.meta.enableSave = true;
  }

  confirm() {
    this.meta.saving = true;
    let payload = {
      animalId: this.jockey.animalId,
      // jockeyId: Number(this.jockey.jockeyId),
      yearOfRace:this.jockey.yearOfRace,
      raceId:this.jockey.raceId,
      divisionSequence:this.jockey.divisionSequence,
      position: Number(this.newPosition),
      updatedBy: this.userId,
      requestType: 'amendPosition'
    };
    this.apiService.updatePosition(payload.yearOfRace, payload.raceId, payload.divisionSequence, payload.animalId, payload)
      .subscribe(
        res => {
          // console.log('[ DEBUG ] Jockey Data Saved:', res);
          this.activeModal.close(res);
          this.notification.success(`${this.jockey.jockeyName} position has been updated.`, 'Finishing Position');
        },
        err => {
          console.error('[ DEBUG ] Error updating Jockey', err);
          this.notification.error(`Could't update jockey's position. Check your connection and Try again.`, 'Finishing Position');
          this.meta.saving = false;
        }
      );
  }

  cancel(action) {
    this.activeModal.dismiss(action);
  }

}
